export const GET_RENTAL_HOUSES = 'GET_RENTAL_HOUSES';
export const GET_RENTAL_HOUSE_BY_ID = 'GET_RENTAL_HOUSE_BY_ID';
export const UPDATE_RENTAL_HOUSE = 'UPDATE_RENTAL_HOUSE';
export const DELETE_RENTAL_HOUSE = 'DELETE_RENTAL_HOUSE';
export const CREATE_RENTAL_HOUSE = 'CREATE_RENTAL_HOUSE';
